import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-circular-progress-bar',
  styleUrl: 'signet-circular-progress-bar.scss',
  shadow: false,
})
export class SignetCircularProgressBar {
  @Prop() icon: string;
  @Prop() upperText: string;
  @Prop() lowerText: string;
  @Prop() progress: number | string;

  render() {
    return (
      <div class="circular-progress-bar set-size">
        <div class={`pie-wrapper progress-${this.progress} style-2`}>
          <div class="circular-progress-label">
            <div class="info">
              <signet-icon icon={this.icon} class="icon" />
              <div class="texts">
                <p class="upper-text">{this.upperText}</p>
                <p class="lower-text">{this.lowerText}</p>
              </div>
            </div>
          </div>
          <div class="pie">
            <div class="left-side half-circle"></div>
            <div class="right-side half-circle"></div>
          </div>
          <div class="shadow"></div>
        </div>
      </div>
    );
  }
}
